import React, { useEffect, useCallback, Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Button, Input, Select, Row } from 'antd';
import { useHistory } from 'react-router';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import GetField from '../Components/GetField';
import styles from '../styles';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';
import LeftGrid from '../Components/LeftGrid';
import RightGrid from '../Components/RightGrid';
import {
  clearCustomers,
  getCustomers,
  getProduct,
  clearProduct,
} from '../Actions';
import Breadcrumbs from '../Components/Breadcrumbs';

const AntInput = GetField(Input);
const AntSelect = GetField(Select);
const { Option } = Select;
const AntInputTextArea = GetField(Input.TextArea);

const UpdateProduct = props => {
  const { classes, match } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const { handleSubmit, control, reset } = useForm();

  const [confirmLoading, setConfirmLoading] = useState(false);

  const customers = useSelector(state => state.customers);
  const product = useSelector(state => state.product);

  useEffect(() => {
    dispatch(getCustomers());
    dispatch(getProduct(match.params.id));
    return () => {
      dispatch(clearCustomers());
      dispatch(clearProduct());
    };
  }, []);

  useEffect(() => {
    reset(product);
  }, [product]);

  const onSubmit = useCallback(async formValues => {
    try {
      setConfirmLoading(true);
      await Api.put(`/products/${match.params.id}`, formValues);
      successNotification('Product updated');
      history.push('/products/list');
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  }, []);

  return (
    <>
      <Breadcrumbs
        moduleName="Product"
        moduleLink="/products/list"
        subModuleName="Update"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <LeftGrid>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Name"
                  placeholder="Name"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="customerId"
              control={control}
              render={({ field }) => (
                <AntSelect
                  allowClear
                  label="Customer"
                  placeholder="Select customer"
                  {...field}
                >
                  {customers.map(customer => (
                    <Option key={customer.id} value={customer.id}>
                      {customer.name}
                    </Option>
                  ))}
                </AntSelect>
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="remark"
              control={control}
              render={({ field }) => (
                <AntInputTextArea
                  allowClear
                  label="Remark"
                  placeholder="Remark"
                  {...field}
                />
              )}
            />
          </LeftGrid>
        </Row>
        <br />
        <Row className={classes.buttonContainer}>
          <Button type="primary" loading={confirmLoading} htmlType="submit">
            Submit
          </Button>
        </Row>
      </form>
    </>
  );
};

UpdateProduct.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withStyles(styles)(UpdateProduct);
